<template>
  <mdb-container style="margin-top: 6em">
    <section class="text-justify text-monospace my-5">
      <h2 class="h1-responsive font-weight-bold my-5 text-center">美国L1签证</h2>
      <p class="w-responsive mx-auto mb-5">
        <span class="mr-4"></span>L-1A创业工签是为跨国公司将公司内部的经理级高管或行政主管派遣到美国的分公司、子公司、母公司或者附属公司担任高管或参与美国公司办公室筹建，进行直接管理而设计的非移民类签证。此类签证没有名额限制、无需抽签。
      </p>
      <mdb-row class="">
        <mdb-col lg="4" md="12" class="mb-lg-0 mb-4">
          <mdb-view class="overlay rounded z-depth-1">
            <img src="../assets/images/us/5.jpg" alt="sample photo" class="img-fluid"/>
            <a>
              <mdb-mask waves overlay="white-slight"/>
            </a>
          </mdb-view>
          <mdb-card-body class="pb-0">
            <h4 class="font-weight-bold my-3 text-center">申请要求</h4>
            <h5>对申请人</h5>
            <p>1、在过往3年内为美国境外的从属公司工作至少一年</p>
            <p>2、在中国公司担任经营/管理工作</p>
            <p>3、申请人需要有与美国业务匹配的管理经验和资质</p>
            <p>4、调任到美国后继续从事经营/管理工作</p>
            <h5>对企业</h5>
            <p>1、中国公司计划在美国、或已经在美国设立了分公司或子公司</p>
            <p>2、美国公司雇佣合理数量的员工</p>
            <p>3、美国公司和中国公司有合法从属关系</p>
          </mdb-card-body>
        </mdb-col>
        <mdb-col lg="4" md="12" class="mb-lg-0 mb-4">
          <mdb-view class="overlay rounded z-depth-1">
            <img src="../assets/images/us/7.jpg" alt="sample photo" class="img-fluid"/>
            <a>
              <mdb-mask waves overlay="white-slight"/>
            </a>
          </mdb-view>
          <mdb-card-body class="pb-0">
            <h4 class="font-weight-bold my-3 text-center">项目优势</h4>
            <p>1、审批速度快，平均审理周期仅4--6个月，可申请15天加急通道</p>
            <p>2、最长可续签7年，美国公司正常运转满一年即可申办EB-1C转绿卡</p>
            <p>3、配偶和21岁以下未婚子女可以同时获得L2签证，随同申请人登陆美国</p>
            <p>4、配偶持L2签证可以在美自由工作，子女持L2签证可入读美国公立学校</p>
            <p>5、对申请人的年龄、语言、和资产来源均没有要求</p>

          </mdb-card-body>
        </mdb-col>
        <mdb-col lg="4" md="12" class="mb-lg-0 mb-4">
          <mdb-view class="overlay rounded z-depth-1">
            <img src="../assets/images/us/1.jpg" alt="sample photo" class="img-fluid"/>
            <a>
              <mdb-mask waves overlay="white-slight"/>
            </a>
          </mdb-view>
          <mdb-card-body class="pb-0">
            <h4 class="font-weight-bold my-3 text-center">申请流程</h4>
            <p>1、评估签订服务协议</p>
            <p>2、准备材料律师递件I-129.</p>
            <p>3、美国移民局审核I-129.申请获得通过</p>
            <p>4、到领馆面试，获得签证</p>
            <p>5、登陆美国</p>


          </mdb-card-body>
        </mdb-col>
      </mdb-row>
    </section>
  </mdb-container>
</template>

<script>
  export default {
    name: 'UsaL1'
  }
</script>

<style scoped>

</style>
